import Box from '@mui/material/Box';
import debounce from 'debounce-promise';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import {
  Icon,
  MultiSelectField,
  Navigation,
  Page,
  QueryContainer,
  TextField,
} from '../../../components';
import { useStore } from '../../../store';
import { UserRoleOptions } from '../../../store/constants';
import type { UserFilters } from '../store/UserStore';
import UserTable from './UserTable';

const navigation: Navigation = [
  {
    button: { type: 'primary', sx: { mr: 1 } },
    icon: 'plus',
    right: true,
    route: '/users/create',
    title: 'Create User',
  },
  {
    button: { type: 'primary' },
    icon: 'file-invoice-dollar',
    right: true,
    route: '/users/billing',
    title: 'Billing',
  },
];

export default observer(function UserListPage() {
  const { userStore } = useStore();
  const [query] = useState(() =>
    userStore.createQuery({ limit: 200, roles: ['PROVIDER'] }),
  );
  const [searchDelayed] = useState(() => debounce(query.execute, 400));

  const filters = query.filters as UserFilters;

  function setSearch(search: string) {
    query.setFilter('search', search);
    return searchDelayed();
  }

  function setRoles(roles: string[]) {
    query.setFilter('roles', roles);
    query.execute();
  }

  return (
    <Page navigation={navigation}>
      <Box alignItems="center" display="flex" sx={{ pb: 3 }}>
        <TextField
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search by id, name or email…"
          size="small"
          startAdornment={<Icon icon="search" sx={{ mr: 0 }} />}
          sx={{ mr: 2, mt: 0, width: 250 }}
          value={filters.search || ''}
        />
        <MultiSelectField
          onChange={({ value }) => setRoles(value)}
          options={UserRoleOptions}
          placeholder={filters.roles?.length ? '' : 'Any role'}
          size="small"
          sx={{ mt: 0, width: 300 }}
          value={filters.roles}
        />
      </Box>

      <QueryContainer itemsName="users" query={query}>
        {(users) => <UserTable users={users.items} />}
      </QueryContainer>
    </Page>
  );
});
